import { RouteConfig } from "vue-router";
import DashboardComponent from "@/views/dashboard/dashboard.vue";

export const DASHBOARD_ROUTES: RouteConfig[] = [
  {
    path: "/dashboard",
    name: "DashboardComponent",
    component: DashboardComponent,
    meta: {
      requiresAuth: true
    }
  }
];